import { ComplexIdHelper, ConsoleFacade } from '@/shared/helpers';
import { IComplexId } from '@/shared/Models/Index';
import Vue from 'vue';

import * as TypedCandidateProfileModalComponent from '@/public/shared/components/candidate-profile-modal-component/candidate-profile-modal-component';
import CandidateProfileModalComponent from '@/public/shared/components/candidate-profile-modal-component/candidate-profile-modal-component.vue';
import { ICandidate } from '@/shared/api-client/models/candidate';

export class CandidateProfileModalOpener  {

    public static async openAsync(containerElement: Element,
                                    electionId: IComplexId,
                                    showGender: boolean,
                                    candidate: ICandidate,
                                    modalTranslations: { [key: string]: string; },
                                    preventViewChangingLinks = false): Promise<void> {

        const ComponentClass = Vue.extend(CandidateProfileModalComponent);

        const candidateId = ComplexIdHelper.createForCandidature(candidate.id);

        const instance = new ComponentClass({
            propsData: {
                electionId: electionId.id,
                candidatureId: candidateId.id,
                translations: modalTranslations,
                showGender,
                preventViewChangingLinks
            }
        });

        instance.$mount();

        ConsoleFacade.log(`Trying to instantiate candidate profile modal component`, instance, containerElement);

        containerElement.innerHTML = '';

        containerElement.appendChild(instance.$el);

        const typedInstance = instance as TypedCandidateProfileModalComponent.default;

        await typedInstance.openModal();
    }
}
